import { render } from "./FileUploadView.vue?vue&type=template&id=adf6db40"
import script from "./FileUploadView.vue?vue&type=script&lang=js"
export * from "./FileUploadView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__